import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "uv-topbar"
}
const _hoisted_2 = { class: "uv-topbar-title" }
const _hoisted_3 = {
  key: 0,
  class: "uv-topbar-title-total"
}
const _hoisted_4 = { class: "uv-topbar-available" }
const _hoisted_5 = { class: "uv-topbar-tools" }
const _hoisted_6 = { class: "uv-topbar-sort" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Sort by", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "uv-topbar-star" }
const _hoisted_13 = ["href", "aria-label"]
const _hoisted_14 = { class: "uv-topbar-star-count" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "uv-topbar-filterlabel" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Refine Search")
], -1)

import { computed } from 'vue';
	import { useStore } from 'vuex';
	import { StarFilled } from '@/svg';
	import { getSavedVehiclesUrl } from '@/config';
	import FiltersToggle from '@/components/FiltersToggle.vue';
	import { ESortOptions } from '@/enums';

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	const savedVehiclesUrl = getSavedVehiclesUrl();

	const store = useStore();

	const hasMadeInitialUpdateVehicles = computed(() => store.state.hasMadeInitialUpdateVehicles);
	const hasFinishedInitialDataRetrieval = computed(() => hasMadeInitialUpdateVehicles.value);

	const showTotalVehicles = computed(() => store.state.totalVehicles != -1);
	const totalVehicles =  computed(() => store.state.totalVehicles);
	const numSavedVehicles = computed(() => store.state.savedVehicles.length);
	const vehicleText = computed((): string => (window as any).uvBrandId === 5 ? "Machine" : "Car");
	const vehicleTextPlural = computed((): string => vehicleText.value + "s");
	const totalVehiclesText = computed((): string => store.state.vehicles.length === 1 ? vehicleText.value : vehicleTextPlural.value);
	const dealerName: string = (window as any).uvDealerName;

	const handleSortchange = (e: Event) => {
		store.commit('setSort', (e.target as HTMLInputElement).value ? parseInt((e.target as HTMLInputElement).value) : 0);
		store.dispatch('updateVehicles', { amend: false });
	};

return (_ctx: any,_cache: any) => {
  return (_unref(hasFinishedInitialDataRetrieval))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FiltersToggle),
          (_unref(showTotalVehicles))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("strong", null, _toDisplayString(_unref(totalVehicles)), 1),
                _createTextVNode(" " + _toDisplayString(_unref(totalVehiclesText)), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, "for sale at " + _toDisplayString(_unref(dealerName)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("select", {
              "aria-label": "sort by",
              class: "uv-select",
              onChange: handleSortchange
            }, [
              _hoisted_7,
              _createElementVNode("option", {
                value: _unref(ESortOptions).PriceLowToHigh
              }, "Price: Low to High", 8, _hoisted_8),
              _createElementVNode("option", {
                value: _unref(ESortOptions).PriceHighToLow
              }, "Price: High to Low", 8, _hoisted_9),
              _createElementVNode("option", {
                value: _unref(ESortOptions).YearLowToHigh
              }, "Year: Low to High", 8, _hoisted_10),
              _createElementVNode("option", {
                value: _unref(ESortOptions).YearHighToLow
              }, "Year: High to Low", 8, _hoisted_11)
            ], 32)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", {
            href: _unref(savedVehiclesUrl),
            "aria-label": 'View your saved ' + _unref(vehicleTextPlural)
          }, [
            _createVNode(_unref(StarFilled)),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(numSavedVehicles)), 1)
          ], 8, _hoisted_13)
        ]),
        _hoisted_15
      ]))
    : _createCommentVNode("", true)
}
}

})